/**
 * User Service - Serviço para gerenciamento de usuários
 *
 * Fornece métodos para atualizar dados do usuário, avatar e senha
 */

import { api } from './api';

export interface UpdateUserData {
  nome?: string;
  sobrenome?: string;
  email?: string;
  telefone?: string;
  cpf?: string;
}

export interface ChangePasswordData {
  id_user: string;
  senhaAntiga: string;
  senha: string;
  confirmSenha: string;
}

export const userService = {
  /**
   * PATCH /usuario/atualiza-user/:id_user
   * Atualiza informações do usuário (nome, telefone, etc)
   */
  updateUser: async (userId: string, data: UpdateUserData): Promise<any> => {
    const response = await api.patch(`/usuario/atualiza-user/${userId}`, data);
    return response.data;
  },

  /**
   * PATCH /usuario/atualiza-avatar/:id_user
   * Atualiza o avatar do usuário
   */
  updateAvatar: async (userId: string, file: File): Promise<any> => {
    const formData = new FormData();
    formData.append('avatar', file);

    const response = await api.patch(`/usuario/atualiza-avatar/${userId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  /**
   * PATCH /usuario/senha
   * Altera a senha do usuário autenticado
   */
  changePassword: async (data: ChangePasswordData): Promise<any> => {
    const response = await api.patch('/usuario/senha', data);
    return response.data;
  },

  /**
   * PUT /user/remove-avatar/:id_user
   * Remove o avatar do usuário
   */
  removeAvatar: async (userId: string): Promise<any> => {
    const response = await api.put(`/user/remove-avatar/${userId}`);
    return response.data;
  },

  /**
   * GET /usuario/get-plan/:id_user
   * Busca o plano atual do usuário e suas assinaturas
   */
  getPlan: async (userId: string): Promise<any> => {
    const response = await api.get(`/usuario/get-plan/${userId}`);
    return response;
  },
};

export default userService;
